import React from 'react';
import cx from 'classnames';
import styles from '../../EmptyState.module.scss';
const Image = ({ className, ...rest }) => {
    return (React.createElement("div", { className: cx(styles.image, className) },
        React.createElement("img", { ...rest })));
};
export default Image;
